import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Profile.css";


const Profile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleMyaccountClick = () => {
    setIsOpen(false);
    navigate("/myaccount");
  };

  return (
    <div
      className="profile-container nav-icons"
      onMouseEnter={() => setIsOpen(true)}
      onMouseDown={() => setIsOpen(true)}
    >
      <img src='/assets/profile.png' alt='profile' className='icon-image'/>
      <span>Profile</span>

      {isOpen && (
        <div className="profile-dropdown">
          <div className="dropdown-item" onClick={handleMyaccountClick}>
            📦 <span>My account</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;

